<template>
  <div class="tw-h-full">
    <div class="tw-bg-gray-50 tw-rounded-lg tw-p-5 tw-h-full">

      <MenuList />
      
    </div>
  </div>
</template>

<script>
import MenuList from '../components/MenuList.vue'

export default {
  components: { MenuList },

  data() {
    return {
      
    }
  },

}
</script>

<style scoped>
</style>